import styled from "styled-components";

// ==================== HEADER / INPUT ====================
export const Header = styled.div`
  padding: 0px 15px;
  border-radius: 8px;
  font-size: var(--app-font-size);
  font-weight: bold;

  @media (max-width: 768px) {
    padding: 0px 10px;
  }
`;

export const PatientInput = styled.input`
  padding: 8px 12px;
  width: 180px;
  height: 31px;
  border: var(--border-medium);
  border-radius: var(--radius-sm);
  font-size: var(--app-font-size);
  font-family: var(--font-body);
  transition: all 0.2s ease;
  background: var(--color-surface-base);

  &:focus {
    outline: none;
    border-color: var(--color-accent);
    box-shadow: 0 0 0 3px rgba(3, 105, 161, 0.15);
  }

  @media (max-width: 768px) {
    width: 140px;
    padding: 5px 6px;
  }

  @media (max-width: 480px) {
    width: 120px;
    font-size: 0.85rem;
  }
`;

export const PatientSelect = styled.select`
  padding: 5px 11px;
  height: 31px;
  margin-right: 12px;
  border-radius: var(--radius-sm);
  border: var(--border-medium);
  font-size: var(--app-font-size);
  font-family: var(--font-body);
  background-color: var(--color-surface-base);
  color: var(--color-text-title);
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: var(--color-accent);
    box-shadow: 0 0 0 3px rgba(3, 105, 161, 0.15);
  }

  @media (max-width: 768px) {
    padding: 5px 6px;
    margin-right: 8px;
  }

  @media (max-width: 480px) {
    padding: 4px 5px;
    margin-right: 5px;
    font-size: 0.85rem;
  }
`;

// ==================== CARDS ====================
export const CardsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    gap: 10px;
  }

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

export const Card = styled.div`
  display: flex;
  flex: 1 1 calc(50% - 10px);
  min-width: 280px;
  padding: 5px 10px;
  border: var(--border-subtle);
  border-radius: var(--radius-md);
  box-sizing: border-box;
  background-color: var(--color-surface-base);
  box-shadow: var(--shadow-sm);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
  }

  @media (max-width: 1200px) {
    flex: 1 1 calc(50% - 8px);
    min-width: 250px;
  }

  @media (max-width: 768px) {
    flex: 1 1 100%;
    min-width: unset;
    padding: 0px 12px;
  }

  @media (max-width: 480px) {
    padding: 0px 10px;
    border-radius: 6px;
  }
`;

export const CardTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  // gap: 4px;

  @media (max-width: 480px) {
    gap: 0px;
  }
`;

export const CardText = styled.div`
  margin-bottom: 2px;
  font-size: var(--app-font-size);
  line-height: 1.4;

  @media (max-width: 480px) {
    font-size: 0.9rem;
    margin-bottom: 1px;
  }
`;

export const ScrollableGroupList = styled.div`
  max-height: 90px;
  overflow-y: auto;
  width: 100%;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: #dc3545 #f1f5f9;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #dc3545;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #bb2d3b;
  }
`;

// ==================== TABLE ====================
export const TableWrapper = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
  border: var(--border-subtle);
  border-radius: var(--radius-md);
  box-sizing: border-box;
  background-color: var(--color-surface-base);
  box-shadow: var(--shadow-sm);

  /* Scrollbar personalizado */
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  @media (max-width: 768px) {
    border-radius: 6px;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
  }

  @media (max-width: 480px) {
    border-radius: 4px;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  min-width: 600px; // Asegura que la tabla tenga un ancho mínimo

  @media (max-width: 768px) {
    min-width: 500px;
  }
`;

export const Th = styled.th`
  background-color: var(--color-surface-muted);
  color: var(--color-text-title);
  padding: 0px 12px;
  position: sticky;
  top: 0;
  z-index: 10;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
  white-space: nowrap;
  border-bottom: var(--border-medium);

  @media (max-width: 768px) {
    padding: 8px 6px;
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    padding: 6px 4px;
    font-size: 0.85rem;
  }
`;

export const Td = styled.td`
  padding: 0px 6px;
  font-size: var(--app-font-size);
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
  background-color: ${(props) => (props.$striped ? "rgba(241, 245, 249, 0.7)" : "transparent")};

  @media (max-width: 768px) {
    padding: 6px 4px;
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    padding: 5px 3px;
    font-size: 0.85rem;
  }
`;

export const TdEst = styled.td`
  padding: 0px 6px;
  text-align: center;
  font-size: var(--app-font-size);
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
  background-color: ${(props) => (props.$striped ? "rgba(241, 245, 249, 0.7)" : "transparent")};

  @media (max-width: 768px) {
    padding: 6px 4px;
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    padding: 5px 3px;
    font-size: 0.85rem;
  }
`;

export const TdDesc = styled.td`
  padding: 0px 6px;
  font-size: var(--app-font-size);
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
  max-width: 300px;
  background-color: ${(props) => (props.$striped ? "rgba(241, 245, 249, 0.7)" : "transparent")};
  
  @media (max-width: 768px) {
    padding: 6px 4px;
    font-size: 0.9rem;
    max-width: 200px;
  }

  @media (max-width: 480px) {
    padding: 5px 3px;
    font-size: 0.85rem;
    max-width: 150px;
  }
`;

export const StatusCircle = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${(props) => props.color || "gray"};
  display: inline-block;

  @media (max-width: 480px) {
    width: 14px;
    height: 14px;
  }
`;

export const IconGroup = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;

  img {
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.40);
    }

    &:active {
      transform: scale(0.95);
    }
  }

  @media (max-width: 768px) {
    gap: 6px;
  }

  @media (max-width: 480px) {
    gap: 4px;
  }
`;
export const IconAlert = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;

  img {
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.40);
    }

    &:active {
      transform: scale(0.95);
    }
  }

  @media (max-width: 768px) {
    gap: 6px;
  }

  @media (max-width: 480px) {
    gap: 4px;
  }
`;

// ==================== INPUT WRAPPER ====================
export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 6px;

  @media (max-width: 768px) {
    gap: 6px;
    margin-bottom: 10px;
  }

  @media (max-width: 480px) {
    gap: 5px;
    margin-bottom: 8px;
  }
`;

export const InputIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  justify-content: flex-start;

  img {
    cursor: pointer;
    transition: transform 0.2s ease, opacity 0.2s ease;

    &:hover {
      transform: scale(1.40);
      opacity: 0.7;
    }

    &:active {
      transform: scale(0.95);
    }
  }

  @media (max-width: 768px) {
    gap: 6px;
  }

  @media (max-width: 480px) {
    gap: 5px;
    flex-wrap: wrap;
  }
`;
